/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import ReactGA from 'react-ga';
import SectionHeader from '../../components/SectionHeader';
import Asset from '../../components/Asset';

const styles = theme => ({
  creators: {
    backgroundColor: theme.palette.grey[100]
  },
  ast: { marginTop: '50px', color: theme.palette.secondary.main },
  img: { boxShadow: '0 0 5px rgba(0,0,0,0.4)' }
});

const Creators = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classes.creators}>
        <div className="wrapper">
          <Grid
            container
            direction="column"
            justify="center"
            style={{ minHeight: '60vh' }}
          >
            <Grid item>
              <SectionHeader
                color="primary"
                text="creators"
                subcolor="secondary"
                subtitle='aka "The WHO*" aka "What twisted minds came with this"'
                img={26}
                imgHeight={38}
              />
            </Grid>

            <Grid item>
              <Grid
                container
                spacing={40}
                alignItems="center"
                alignContent="center"
              >
                <Grid item xs md={1} />

                <Grid item xs={12} md={4}>
                  <div style={{ textAlign: 'center' }}>
                    <img
                      src="/images/cards/anna-bularz.jpg"
                      alt="Anna Bularz"
                      width="100%"
                      className={classes.img}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography gutterBottom variant="h3">
                    Anna Bularz
                  </Typography>
                  <Typography paragraph variant="body1">
                    Her superhero alter ego is The Note-taking Woman and her
                    superpower is writing meticulously on small pieces of paper
                    very fast. Her burning hatred toward ambiguity made the
                    rules of the game as precise as you see them today. A strong
                    character that knows her way around a whip{' '}
                    <Asset img={39} /> in all (and I mean ALL) life situations,
                    kept the team going when we felt all hope was lost. Thinks
                    that pop-culture is something that happens to other people;)
                  </Typography>
                </Grid>
                <Grid item xs md={1} />
                <Grid item xs md={1} />
                <Grid item xs={12} md={4}>
                  <div style={{ textAlign: 'center' }}>
                    <img
                      src="/images/cards/pawel-kozlowski.jpg"
                      alt="Paweł Kozłowski"
                      width="100%"
                      className={classes.img}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography gutterBottom variant="h3">
                    Paweł Kozłowski
                  </Typography>
                  <Typography paragraph variant="body1">
                    A guy who likes to talk a lot and, to the dismay of people
                    around him, is not satisfied with talking to himself. His
                    dark sense of humor helped to shape the copy for the cards
                    and the manual, while his somewhat grim and pessimistic (or
                    as he like to call it realistic) view on life helped to
                    ground the team in the here and now when visions of success
                    and future grandeur ran rampant. A proud member of The
                    United Church of Bacon. <Asset img={29} />
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  spacing={40}
                  alignItems="center"
                  alignContent="center"
                >
                  <Grid item xs md={1} />
                  <Grid item xs={12} md={4}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src="/images/cards/jacek-krecioch.jpg"
                        alt="Jacek Kręcioch"
                        width="100%"
                        className={classes.img}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography gutterBottom variant="h3">
                      Jacek Kręcioch
                    </Typography>
                    <Typography paragraph variant="body1">
                      A big man with an even bigger heart (all his other organs
                      seem to be pretty standard). Relentless in his attention
                      to visual details he's the guy behind the look and feel of
                      the game. His jokes are as funny as they are inappropriate{' '}
                      <Asset img={49} /> and he was the glue that kept the team
                      together. Makes killer scrambled eggs. Video games addict.
                    </Typography>
                  </Grid>
                  <Grid item xs md={1} />
                  <Grid item xs md={1} />
                  <Grid item xs={12} md={4}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src="/images/cards/monika-szewczyk.jpg"
                        alt="Monika Szewczyk"
                        width="100%"
                        className={classes.img}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography gutterBottom variant="h3">
                      Monika Szewczyk
                    </Typography>
                    <Typography paragraph variant="body1">
                      A mysterious artist that created all the visuals for the
                      game. Even though we only communicated by email, after
                      drawing all those u2i people she probably knows everyone
                      better than any person in the company. Her wit and
                      beautiful art <Asset img={36} /> style helped to give life
                      to the game we built and more than anything made the team
                      feel that we have something great on our hands. She's a{' '}
                      <a
                        href="https://www.facebook.com/Birdbirdtales/"
                        target="_blank"
                        style={{ color: '#00a8c2' }}
                        rel="noopener noreferrer"
                        onClick={() => {
                          ReactGA.ga(
                            'send',
                            'event',
                            'order',
                            'link',
                            'birdbirdtale'
                          );
                        }}
                      >
                        parrot living with a hawk.
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item xs md={1} />
                  <Grid item xs md={1} />
                  <Grid item xs={12} md={4}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src="/images/cards/u2i-logo.jpg"
                        alt="u2i logo"
                        width="100%"
                        className={classes.img}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography gutterBottom variant="h3">
                      u2i
                    </Typography>
                    <Typography paragraph variant="body1">
                      Special thanks goes to all the people at{' '}
                      <a
                        href="https://u2i.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#00a8c2' }}
                        onClick={() => {
                          ReactGA.ga('send', 'event', 'order', 'link', 'u2i');
                        }}
                      >
                        u2i
                      </a>
                      . We love you! <Asset img={15} />
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Typography align="right" variant="body2" className={classes.ast}>
            * not the band, but we'll take all the SEO we can get
          </Typography>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Creators);
